import { useEffect, useState } from "react";
import { MessageSquare, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { residentApi, errMsg } from "../lib/api";
import { SUBJECTS } from "../lib/format";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";

const STATUS = { yeni: "Gönderildi", okundu: "Okundu", cozuldu: "Çözüldü" };
const OPTIONS = ["dilek", "sikayet", "ariza", "diger"];

export default function FeedbackPage() {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const [list, setList] = useState([]);

  const load = () => residentApi.get("/resident/messages").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!subject) return toast.error("Lütfen konu seçin");
    setBusy(true);
    try {
      await residentApi.post("/resident/messages", { subject, body });
      toast.success("Talebiniz yönetime iletildi");
      setSubject("");
      setBody("");
      load();
    } catch (er) {
      toast.error(errMsg(er));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14 grid lg:grid-cols-5 gap-8">
      <div className="lg:col-span-3 bg-white rounded-[2rem] border border-black/5 p-6 sm:p-8">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-12 h-12 rounded-2xl bg-[#D8F3DC] text-[#1B4332] flex items-center justify-center"><MessageSquare /></span>
          <div>
            <h1 className="font-display text-2xl font-bold text-slate-800" data-testid="feedback-title">Dilek ve Şikayetler</h1>
            <p className="text-sm text-slate-500">Taleplerinizi doğrudan yönetime iletin.</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <Select value={subject} onValueChange={setSubject}>
            <SelectTrigger className="h-12 rounded-xl" data-testid="feedback-subject-select"><SelectValue placeholder="Konu seçin" /></SelectTrigger>
            <SelectContent>
              {OPTIONS.map((k) => <SelectItem key={k} value={k} data-testid={`feedback-subject-${k}`}>{SUBJECTS[k]}</SelectItem>)}
            </SelectContent>
          </Select>
          <Textarea required minLength={3} rows={7} placeholder="Konuyu detaylı yazınız..." value={body} onChange={(e) => setBody(e.target.value)} className="rounded-xl" data-testid="feedback-body-input" />
          <Button type="submit" disabled={busy} className="h-12 px-8 rounded-full bg-[#1B4332] hover:bg-[#143326] font-bold" data-testid="feedback-submit-btn">
            {busy ? "Gönderiliyor..." : "Yönetime Gönder"}
          </Button>
        </form>
      </div>
      <div className="lg:col-span-2">
        <p className="eyebrow text-[#E07A5F]">Önceki taleplerim</p>
        <div className="mt-4 space-y-3" data-testid="my-messages">
          {list.length === 0 && <p className="text-sm text-slate-500">Henüz talep göndermediniz.</p>}
          {list.map((m) => (
            <div key={m.id} className="bg-white rounded-2xl border border-black/5 p-4" data-testid={`my-message-${m.id}`}>
              <div className="flex items-center justify-between text-xs">
                <span className="font-bold text-[#1B4332]">{SUBJECTS[m.subject]}</span>
                <span className={`inline-flex items-center gap-1 ${m.status === "cozuldu" ? "text-[#2D6A4F]" : "text-slate-400"}`}>
                  {m.status === "cozuldu" && <CheckCircle2 size={12} />} {STATUS[m.status]}
                </span>
              </div>
              <p className="text-sm text-slate-700 mt-2 line-clamp-3">{m.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
